import React from "react";
import { FaLongArrowAltRight } from "@react-icons/all-files/fa/FaLongArrowAltRight";

import body from "../../../../assets/image/category/Body.webp";
import breaks from "../../../../assets/image/category/Breaks.webp";
import clutch from "../../../../assets/image/category/clutch.webp";
import electrical from "../../../../assets/image/category/Electronics.webp";
import engine from "../../../../assets/image/category/engine.webp";
import filters from "../../../../assets/image/category/filters.png";
import fluid from "../../../../assets/image/category/fluid.webp";
import maintenance from "../../../../assets/image/category/maintenance.webp";
import radiators from "../../../../assets/image/category/radiators.webp";
import transfer from "../../../../assets/image/category/transfercase.webp";
import exhaust from "../../../../assets/image/category/exhaust.webp";
import suspension from "../../../../assets/image/category/suspension.webp";
import { Link } from "react-router-dom";
import MyButton from "../utils/Button/MyButton";
const services = [
  {
    title: "Brake",
    image: breaks,
    link: "/breaks",
    description:
      "Expert brake repairs, pads, rotors, and fluid services for safe stopping.",
  },
  {
    title: "Clutch & Transmissions",
    image: clutch,
    link: "/clutch",
    description:
      "Clutch replacement and transmission repairs to ensure smooth gear shifts.",
  },
  {
    title: "Electrical",
    image: filters,
    link: "/electrical",
    description:
      "Electrical system diagnostics and repairs for optimal vehicle performance.",
  },
  {
    title: "Engine Diagnostics",
    image: engine,
    link: "/engine",
    description:
      "Comprehensive engine testing and diagnostics to identify issues early.",
  },
  {
    title: "Exhaust",
    image: exhaust,
    link: "/exhaust",
    description:
      "Exhaust system repairs and replacements for better emissions and performance.",
  },
  {
    title: "Maintenance",
    image: maintenance,
    link: "/maintenance",
    description:
      "Routine vehicle maintenance and inspections to keep your car running smoothly.",
  },
  {
    title: "Radiators & Cooling",
    image: radiators,
    link: "/radiators",
    description:
      "Radiator repairs and cooling system services to prevent overheating.",
  },
  {
    title: "Suspension & Steering",
    image: suspension,
    link: "/suspension",
    description:
      "Suspension and steering component repairs for a comfortable ride.",
  },
  {
    title: "Transfer Case & Differentials",
    image: transfer,
    link: "/transfer",
    description:
      "Transfer case and differential maintenance for all-wheel drive systems.",
  },
  {
    title: "Fuel",
    image: fluid,
    link: "/fuel",
    description:
      "Fuel system cleaning and repairs to improve efficiency and reduce emissions.",
  },
];
export default function OurServices() {
  return (
    <div className="">
      <div className="bg-blue-50 py-[20px] lg:py-[50px] lg:px-[60px]  ">
        <div className="   text-center ">
          <h1 className="lg:text-5xl md:text-3xl text-3xl font-bold text-blue-900 pb-2">
            Our Services
          </h1>
          <hr className="heading-seperator border-4 border-blue-900" />
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:gap-2 gap-3 lg:px-[3.3%] mx-3a  ">
            {services.map((service, index) => (
              <div
                className="max-w-sm  bg-white border  rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 hover:border-blue-400  hover:scale-105 transition-all duration-300 ease-out"
                key={index}
              >
                <img
                  src={service.image}
                  alt="Collection One"
                  className="rounded-t-lg h-[12rem] w-full  object-cover"
                />
                <h5 class="mb-1 text-2xl text-center lg:text-xl font-semibold text-gray-900  mt-2  ps-2">
                  {service.title}
                </h5>
                <p class="mb-1 lg:font-normal h-[3rem] text-center text-gray-700 dark:text-gray-400 lg:text-base text-xl  ps-2">
                  {service.description.length > 50
                    ? service.description.substring(0, 50) + "..."
                    : service.description}
                </p>
                <Link to={`${service.link}`}>
                  <MyButton
                    text="Read More"
                    className=" mx-auto my-3 cursor-pointer transform transition-transform duration-500 hover:scale-110 "
                  />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
